import request from '@/utils/request'

//心理咨询擅长列表
export function getAdeptList(data) {
    return request({
        url: '/backend/psy/adept-direction/list',
        method: 'post',
        data: data
    })
}

//创建擅长标签
export function adeptCreate(data) {
    return request({
        url: '/backend/psy/adept-direction/create',
        method: 'post',
        data: data
    })
}

//擅长标签删除
export function adeptDelete(data) {
    return request({
        url: '/backend/psy/adept-direction/delete',
        method: 'delete',
        data: data
    })
}

//擅长标签删除
export function updateSort(data) {
    return request({
        url: '/backend/psy/adept-direction/update-sort',
        method: 'post',
        data: data
    })
}

//擅长标签删除
export function adeptSet(data) {
    return request({
        url: '/backend/psy/adept-direction/adept-set',
        method: 'post',
        data: data
    })
}
// 获取标签列表
export function getTaglist(data) {
    return request({
        url: '/backend/psy/tag/match-all',
        method: 'post',
        data: data
    })
}
 // 增加标签
export function addTagstore(data) {
    return request({
        url: '/backend/psy/tag/store',
        method: 'post',
        data: data
    })
}
// 获取全部一级标签
export function matchchild(data) {
    return request({
        url: '/backend/psy/tag/match-child',
        method: 'post',
        data: data
    })
}
// 修改标签
export function edittag(data) {
    return request({
        url: '/backend/psy/tag/edit',
        method: 'post',
        data: data
    })
}
// s删除标签
export function destroytag(data) {
    return request({
        url: '/backend/psy/tag/destroy',
        method: 'post',
        data: data
    })
}


// 推荐标签
export function getRecommendTaglist(data) {
    return request({
        url: '/backend/psy/recommend-tag/match-all',
        method: 'post',
        data: data
    })
}
// 获取全部一级标签
export function matchRecommendchild(data) {
    return request({
        url: '/backend/psy/recommend-tag/match-child',
        method: 'post',
        data: data
    })
}
// 删除推荐标签
export function destroyRecommend(data) {
    return request({
        url: '/backend/psy/recommend-tag/destroy',
        method: 'post',
        data: data
    })
}
//推荐擅长标签-排序
export function updateRecommendSort(data) {
    return request({
        url: '/backend/psy/recommend-tag/sort',
        method: 'post',
        data: data
    })
}
//
export function getRecommendInfo(data) {
    return request({
        url: '/backend/psy/recommend-tag/info',
        method: 'post',
        data: data
    })
}
export function updateRecommendInfo(data) {
    return request({
        url: 'backend/psy/recommend-tag/store',
        method: 'post',
        data: data
    })
}
// 推荐擅长方向 列表页开关（显示状态）
export function setRecommendStatus(data) {
    return request({
        url: 'backend/psy/recommend-tag/set-status',
        method: 'post',
        data: data
    })
}